import data from "./types/data";
import meta from "./types/meta";
import query from "./types/query";

const initialState = {
    data,
    query,
    meta
};

const cookingMethodsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'cookingMethods/update':
            return {
                ...state,
                ...action.payload
            };

        case 'cookingMethods/clear':
            return initialState;

        default:
            return state;
    }
};

export default cookingMethodsReducer;